/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconZhankai: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M389.239935 451.21603H46.391759a43.350032 43.350032 0 0 1-43.350032-43.350031V65.025048a43.350032 43.350032 0 0 1 43.350032-43.350032h342.848176a43.350032 43.350032 0 0 1 43.350032 43.350032v342.840951a43.350032 43.350032 0 0 1-43.350032 43.350031z m-299.498144-86.700063h256.148112V108.375079H89.741791v256.140888zM976.23549 451.21603H633.394539a43.350032 43.350032 0 0 1-43.350032-43.350031V65.025048a43.350032 43.350032 0 0 1 43.350032-43.350032h342.840951a43.350032 43.350032 0 0 1 43.350032 43.350032v342.840951a43.350032 43.350032 0 0 1-43.350032 43.350031z m-299.490919-86.700063h256.140887V108.375079H676.744571v256.140888zM389.239935 1007.801538H46.391759a43.350032 43.350032 0 0 1-43.350032-43.350032V621.60333a43.350032 43.350032 0 0 1 43.350032-43.350031h342.848176a43.350032 43.350032 0 0 1 43.350032 43.350031v342.848176a43.350032 43.350032 0 0 1-43.350032 43.350032z m-299.498144-86.700063h256.148112V664.953362H89.741791v256.148113zM976.23549 1007.801538H633.394539a43.350032 43.350032 0 0 1-43.350032-43.350032V621.60333a43.350032 43.350032 0 0 1 43.350032-43.350031h342.840951a43.350032 43.350032 0 0 1 43.350032 43.350031v342.848176a43.350032 43.350032 0 0 1-43.350032 43.350032z m-299.490919-86.700063h256.140887V664.953362H676.744571v256.148113z"
        fill={getIconColor(color, 0, '#231815')}
      />
    </svg>
  );
};

IconZhankai.defaultProps = {
  size: 18,
};

export default IconZhankai;
